import "./TermsConditions.module.css";
import Header from "@/reusable_sections/Header";
import Legal from "./sections/Legal";
import Siteheader from "./sections/Siteheader";
import TrustSignals from "./sections/TrustSignals";
import LegalLimitation from "./sections/LegalLimitation";
import Footer from "@/reusable_sections/Footer";
export default function TermsConditionsPage() {
  return <div>
      <Header />
      <Legal />
      <Siteheader />
      <TrustSignals />
      <LegalLimitation />
      <Footer />
    </div>;
}